<template>
  <div class="image-viewer">
    <div @click="openModal" class="image-viewer-container">
      <slot v-if="slot" />
      <img
        v-else-if="src"
        :src="src"
        :alt="alt || 'image'"
        style="width: 80px; height: 80px; object-fit: cover"
        ref="image"
        @error="handleImageError"
      />
      <div
        v-else
        class="no-image-placeholder bg-primary bg-lighten-2 text-white"
        style="
          width: 80px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #f8f8f8;
          color: #6e6b7b;
          text-align: center;
          font-size: 0.8rem;
          border-radius: 4px;
        "
      >
        <feather-icon icon="ImageIcon" />
        No Media
      </div>
    </div>

    <!-- Modal with image carousel -->
    <b-modal
      id="image-viewer-modal"
      v-model="isModalOpen"
      centered
      controls
      indicators
      size="xl"
      title="Image Viewer"
      hide-footer
      hide-header
      body-class="p-0"
      class="image-viewer-modal"
    >
      <b-carousel
        id="image-carousel"
        :value="activeIndex"
        :interval="0"
        indicators
        controls
        background="#000"
        style="max-height: 80vh"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-button
          variant="outline-secondary"
          class="btn-icon"
          @click="closeModal"
          style="position: absolute; top: 10px; right: 10px; z-index: 1000"
        >
          <feather-icon icon="XIcon" />
        </b-button>
        <b-carousel-slide
          v-for="(image, index) in images"
          :key="`image-${index}`"
          :img-src="image"
          class="image-slide"
        />
      </b-carousel>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCardFooter,
  BCardHeader,
  BCardTitle,
  BCarousel,
  BCarouselSlide,
  BModal,
  BModalBody,
} from 'bootstrap-vue';

export default {
  name: 'ImageViewer',
  components: {
    BModal,
    BCarousel,
    BCarouselSlide,
    BButton,
    BModalBody,
    BCardFooter,
    BCardHeader,
    BCardTitle,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    src: {
      type: String,
      required: false,
    },
    alt: {
      type: String,
      required: false,
    },
    slot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: 0,
      isModalOpen: false,
      sliding: false,
      imageError: false,
    };
  },
  mounted() {
    this.activeIndex = this.initialIndex || 0;
  },
  methods: {
    openModal() {
      if (!this.imageError && (this.src || this.slot)) {
        this.isModalOpen = true;
      }
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
      this.activeIndex = slide;
    },
    previousImage() {
      this.activeIndex--;
    },
    nextImage() {
      this.activeIndex++;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    handleImageError() {
      this.imageError = true;
      const img = this.$refs.image;
      if (img) {
        const parent = img.parentNode;
        if (parent) {
          // Create a div to replace the image
          const div = document.createElement('div');
          div.className = 'failed-image-placeholder bg-primary bg-lighten-2 text-white';
          div.style.width = '80px';
          div.style.height = '80px';
          div.style.display = 'flex';
          div.style.alignItems = 'center';
          div.style.justifyContent = 'center';
          div.style.backgroundColor = '#f8f8f8';
          div.style.color = '#6e6b7b';
          div.style.textAlign = 'center';
          div.style.fontSize = '0.8rem';
          div.style.borderRadius = '4px';
          div.innerText = 'Failed to media';

          // Replace the image with the div
          parent.replaceChild(div, img);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image-viewer {
  cursor: pointer;

  .image-viewer-container {
    border-radius: 10px;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
#image-viewer-modal {
  .modal-content {
    width: 100%;
    height: 80vh;
    background-color: transparent;

    .modal-body {
      .carousel.slide {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        overflow: hidden;

        .carousel-inner {
          width: 100%;
          height: 100%;

          .carousel-item {
            width: 100%;
            height: 100%;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
      }
    }
  }
}
</style>
